import Navbar from "./Navbar";
import Hero from "./Hero";
import Problem from "./Problem";
import HowItWorks from "./HowItWorks";
import DayWithEmPi from "./DayWithEmPi";
import WhyDifferent from "./WhyDifferent";
import Philosophy from "./Philosophy";
import Roadmap from "./Roadmap";
import Waitlist from "./Waitlist";
import FAQ from "./FAQ";
import Footer from "./Footer";
import { empiTheme } from "./styles/empiTheme";

export default function Home() {
  return (
    <div style={page}>
      <Navbar />
      <main style={main}>
        <Hero />
        <Problem />
        <HowItWorks />
        <DayWithEmPi />
        <WhyDifferent />
        <Philosophy />
        <Roadmap />
        <Waitlist />
      </main>
      <FAQ />
      <Footer />
    </div>
  );
}

const page = {
  background: empiTheme.colors.background,
  color: empiTheme.colors.text,
  minHeight: "100vh",
};

const main = {
  display: "block",
};
